<template>
    <div class="container">
        <div v-if="isLoading" class="progress-bar">
            <v-progress-circular
                indeterminate
                size="50"
                color="amber"
            ></v-progress-circular>
        </div>
        <div v-if="showDisplay" class="request__content mt-8">
            <v-img
                class="request__illustration mx-auto"
                src="../assets/marketplace-illustration.svg"
            />
            <h1 class="title font-medium mt-5">
                Oh no, you don't have access yet!
            </h1>
            <p class="text font-gray">
                {{ desc_text }}
            </p>
            <div class="request__actions">
                <v-btn
                    rounded="lg"
                    color="#FFDF8C"
                    class="mt-7"
                    @click="requestAccess"
                >
                    {{ button_text }}
                </v-btn>
                <p class="text-sm mt-2" @click="requestAccess">{{ alt_text }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getFirestore,
    doc,
    updateDoc,
    getDoc,
    arrayUnion,
} from "firebase/firestore";
import store from "@/store";
import { ref } from "vue";

export default {
    props: {
        desc_text: String,
        button_text: String,
        alt_text: String,
        feature_name: String,
    },
    setup(props) {
        const isLoading = ref(false);
        const showDisplay = ref(true);
        const db = getFirestore();
        const userRef = doc(db, "users", store.state.user?.user_id);

        // Atomically add a new region to the "regions" array field.
        const requestAccess = () => {
            showDisplay.value = false;
            isLoading.value = true;
            updateDoc(userRef, {
                features: arrayUnion(props.feature_name),
            })
                .then(() => {
                    getDoc(userRef)
                        .then((doc) => {
                            const current_user = doc.data();

                            // Store in state
                            store.dispatch("setCurrentUser", current_user);
                        })
                        .catch(() =>
                            console.log("Failed to fetch user from DB")
                        );
                })
                .then(() => (isLoading.value = false));
        };

        return {
            requestAccess,
            isLoading,
            showDisplay,
        };
    },
};
</script>

<style lang="scss" scoped>
.progress-bar {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.request {
    &__content {
        width: 100%;
        max-width: 800px;
        text-align: center;

        // position: absolute;
        // top: 50%;
        // left: 50%;
        // transform: translate(-50%, -50%);
    }
    &__illustration {
        width: 70%;
    }
    &__actions p {
        cursor: pointer;
    }
}
.container{
    display:flex;
    justify-content:center;
    align-items:center;
}
</style>
